import React from "react";
import ClassNames from "classnames";
import NavigationBreadcrumbs, {
  type NavigationBreadcrumbItem,
} from "../NavigationBreadcrumbs/NavigationBreadcrumbs";
import "./PageHeader.scss";

export interface PageHeaderProps {
  breadcrumbs: NavigationBreadcrumbItem[];
  actions?: React.ReactNode;
  className?: string;
  "data-testid"?: string;
}

const PageHeader: React.FC<PageHeaderProps> = ({
  breadcrumbs,
  actions,
  className = "",
  "data-testid": dataTestId,
}) => {
  if (!breadcrumbs?.length) return null;

  return (
    <div
      className={ClassNames("page-header", className)}
      data-testid={dataTestId}
    >
      <div className="page-header-title">
        <NavigationBreadcrumbs items={breadcrumbs} />
      </div>
      {!!actions && <div className="page-header-actions">{actions}</div>}
    </div>
  );
};

export default PageHeader;
